import React, { useState } from "react";

import { useSelector } from "react-redux";

import { ParentSaleTabs, ParentSaleTabType } from "constants/sale";
import { Settings } from "constants/settings";

import { getSaleLotsBySaleForBusinessUser, getSetting } from "selectors";

import { useIsMobile } from "hooks";

import { BusinessUserBuyerCards } from "./BusinessUserBuyerCards";
import { BusinessUserSaleLotsTable } from "./BusinessUserSaleLotsTable";

const BusinessUserSaleLotsView = (): React.JSX.Element => {
  const isScreenSizeMobile: boolean = useIsMobile();
  const [isMobile, setIsMobile] = useState<boolean>(isScreenSizeMobile);
  const saleLots: SaleLot[] = useSelector(getSaleLotsBySaleForBusinessUser);

  const parentSaleTab: ParentSaleTabType = useSelector(
    getSetting(Settings.parentSaleTab),
  );

  const viewingAsBuyer: boolean = parentSaleTab === ParentSaleTabs.BOUGHT;

  if (isMobile && viewingAsBuyer) {
    if (saleLots.length > 0) {
      return <BusinessUserBuyerCards setIsMobile={setIsMobile} />;
    }
    return <p className="text-center">No rows to show</p>;
  }

  return <BusinessUserSaleLotsTable setIsMobile={setIsMobile} />;
};

export default BusinessUserSaleLotsView;
